module.exports = "./img/bf3fa40f00a5f0279058d103226ee73a.png";